export default __webpack_public_path__ + "static/media/card.ca3311d0.png";